"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.StyledTooltip = exports.StyledTitle = void 0;
const styled_components_1 = __importDefault(require("styled-components"));
const wl_ui_kit_1 = require("@invent/wl-ui-kit");
exports.StyledTitle = (0, styled_components_1.default)(wl_ui_kit_1.Heading4) `
  /* stylelint-disable-next-line value-no-vendor-prefix */
  display: -webkit-box;
  -webkit-line-clamp: 1;
  -webkit-box-orient: vertical;
  /* stylelint-disable-next-line property-no-unknown */
  line-clamp: 1;
  /* stylelint-disable-next-line property-no-unknown */
  box-orient: vertical;
  overflow: hidden;
  font-weight: 700;
  ${({ theme }) => (0, wl_ui_kit_1.getMixinFromTheme)('widgetHeadingMixin')({ theme })}
`;
exports.StyledTooltip = (0, styled_components_1.default)(wl_ui_kit_1.Tooltip) `
  box-shadow: none;

  & div {
    margin: ${(0, wl_ui_kit_1.getSizeBy)(1.5)};
    background: ${(0, wl_ui_kit_1.getColor)('onSurface')};
  }

  & div:first-child {
    width: ${(0, wl_ui_kit_1.getSizeBy)(3)};
    height: ${(0, wl_ui_kit_1.getSizeBy)(3)};
    margin-left: -${(0, wl_ui_kit_1.getSizeBy)(0.75)};
  }

  & div:last-child {
    max-width: ${(0, wl_ui_kit_1.getSizeBy)(50)};
  }
`;
